import parse from "html-react-parser";

const ErrorFallbackUI = ({ message = "Failed to load" }) => {
  return (
    <div className="w-100 h-100 justify-content-center align-items-center">
      {parse(message || "")}
    </div>
  )
}

export default ErrorFallbackUI;